export default "__VITE_ASSET__Dgi7XU$A__"